"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render(_c, _vm) {
  return _c('div', {
    directives: [{
      name: "rawElement",
      rawName: "v-rawElement",
      value: {
        el: _vm.props.pluginElement,
        props: {
          kiwi: {
            ..._vm.props.pluginProps
          }
        }
      },
      expression: "{\n        el: props.pluginElement,\n        props: {\n            kiwi: {\n                ...props.pluginProps,\n            },\n        },\n    }"
    }],
    class: {
      [_vm.data.staticClass]: _vm.data.staticClass
    }
  });
};
var staticRenderFns = exports.staticRenderFns = [];